// Roboto font data embedded as base64 strings for jsPDF.
// Source: GitHub project max-barry/google-drive-cms (Roboto licensed under Apache 2.0).

import robotoRegular from './Roboto-Regular.base64?raw';
import robotoMedium from './Roboto-Medium.base64?raw';

export interface EmbeddedFont {
  file: string;
  data: string;
  style: 'normal' | 'bold' | 'italic' | 'bolditalic';
}

export const robotoFonts: EmbeddedFont[] = [
  {
    file: 'Roboto-Regular.ttf',
    data: robotoRegular.trim(),
    style: 'normal',
  },
  {
    file: 'Roboto-Medium.ttf',
    data: robotoMedium.trim(),
    style: 'bold',
  },
  {
    file: 'Roboto-Regular-Italic.ttf',
    data: robotoRegular.trim(),
    style: 'italic',
  },
  {
    file: 'Roboto-Medium-BoldItalic.ttf',
    data: robotoMedium.trim(),
    style: 'bolditalic',
  },
];
